import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Timmer } from '../../models';

@Component({
  selector: 'lib-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit {

  title: string = 'Éxito';
  doneBtnName: string = null;
  closeBtnName: string = null;
  retryBtnName: string = 'Reenviar';
  type: string = 'primary';
  message: string = '';
  //OTP
  adnFieldName: string = '@OTP';
  inputLabel: string = 'Código de verificación';
  inputFieldValue: string = null;
  timmer: Timmer;
  retryTime: number = 1;

  @Output() onDoneBtn: EventEmitter<AlertDialogComponent> = new EventEmitter<AlertDialogComponent>();
  @Output() onCancelBtn: EventEmitter<AlertDialogComponent> = new EventEmitter<AlertDialogComponent>();
  @Output() onRetryBtn: EventEmitter<AlertDialogComponent> = new EventEmitter<AlertDialogComponent>();


  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    this.timmer = new Timmer(this.retryTime)
    this.timmer.startTimmer();
  }

  onDone() {
    this.onDoneBtn.emit(this);
    if (this.type != 'OTP')
      this.bsModalRef.hide()
  }

  onCancel() {
    this.onCancelBtn.emit(this);
    this.bsModalRef.hide()
  }

  onRetry() {
    this.onRetryBtn.emit(this);
    this.timmer = new Timmer(this.retryTime)
    this.timmer.startTimmer();
    // this.bsModalRef.hide()
  }

  getMessageFormated() {
    return this.message.replace("\n", "<br/><br/>");
  }

  getIconColor() {
    switch (this.type) {
      case 'success':
        return '#5cb85c';
      case 'error':
        return '#fa0101';
      case 'info':
      case 'def':
        return '#002e5b';
      case 'OTP':
        return '#002e5b';
      default:
        return '#002e5b';
    }
  }

  getIcon() {
    switch (this.type) {
      case 'success':
        return 'fa fa-check';
      case 'error':
        return 'fa fa-exclamation-circle';
      case 'info':
      case 'def':
        return 'fa fa-exclamation';
      case 'OTP':
        return 'fa fa-exclamation';
      default:
        return '';
    }
  }

}